import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DialogActionsEnum, IDialogTrigger } from '../../dialog.data';
import { DialogService } from '../../dialog.service';
import { filter, takeUntil } from 'rxjs/operators';

export const DIALOG_TYPE = 'global-error';

export interface IErrorDialogData {
  okText?: string;
  errorTitle?: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: 'error-dialog.component.html',
  styleUrls: ['error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent implements OnInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  dialogType: string;
  okText: string;
  errorTitle: string;
  errorMessage: string;

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;

    const defaultOkText = this._translateService.instant('ACTION.OK');
    const defaultErrorTitle = this._translateService.instant(
      'DIALOG.ERROR.TITLE'
    );

    this._dialogService.dialogTriggers$
      .pipe(
        filter((dialogTrigger: IDialogTrigger) => {
          return (
            dialogTrigger.type === this.dialogType &&
            dialogTrigger.action === DialogActionsEnum.open
          );
        }),
        takeUntil(this._destroyed)
      )
      .subscribe((dialogTrigger: IDialogTrigger) => {
        const dialogData: IErrorDialogData = dialogTrigger.data;

        this.okText = dialogData.okText || defaultOkText;
        this.errorTitle = dialogData.errorTitle || defaultErrorTitle;
        this.errorMessage = dialogData.errorMessage || '';

        this._changeDetectorRef.markForCheck();
        this._changeDetectorRef.detectChanges();
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
